import { api } from "@/lib/api";

let airports = null;
let airlines = null;
export const loadAirports = () => (airports = airports || api.get("/airports").then((r) => r.data).catch((e) => { airports = null; throw e; }));
export const loadAirlines = (fresh = false) => {
  if (fresh) airlines = null;
  return (airlines = airlines || api.get("/airlines").then((r) => r.data).catch((e) => { airlines = null; throw e; }));
};

export const LEGS = [["outbound", "Vuelo de ida"], ["inbound", "Vuelo de regreso"]];
export const EMPTY_SEG = { from_code: "", to_code: "", airline: "", flight_no: "", dep_date: "", dep_time: "", arr_date: "", arr_time: "" };
export const EMPTY_FLIGHTS = { outbound: [], inbound: [] };
export const logoUrl = (code) => `${process.env.REACT_APP_BACKEND_URL}/api/public/airline-logo/${code}`;
export const airportLabel = (a) => (a ? `${a[0]} · ${a[2] || a[1]}` : "");

const filled = (s) => Object.keys(EMPTY_SEG).some((k) => String(s[k] || "").trim());

export const cleanFlights = (f) => {
  const out = {};
  LEGS.forEach(([leg]) => {
    const segs = (f?.[leg] || []).filter(filled);
    if (segs.length) out[leg] = segs;
  });
  return Object.keys(out).length ? out : null;
};

export const flightsToForm = (f) => {
  const seg = (s) => ({ ...EMPTY_SEG, ...Object.fromEntries(Object.entries(s).map(([k, v]) => [k, v ?? ""])) });
  return { outbound: (f?.outbound || []).map(seg), inbound: (f?.inbound || []).map(seg) };
};

export const flightErrors = (f) => {
  const e = {};
  LEGS.forEach(([leg]) => {
    (f?.[leg] || []).forEach((s, i) => {
      if (!filled(s)) return;
      const p = `flights.${leg}.${i}.`;
      if (!s.from_code) e[`${p}from_code`] = "Elige el aeropuerto";
      if (!s.to_code) e[`${p}to_code`] = "Elige el aeropuerto";
      if (s.from_code && s.from_code === s.to_code) e[`${p}to_code`] = "La llegada debe ser distinta de la salida";
      if (s.dep_date && s.arr_date && (s.arr_date < s.dep_date || (s.arr_date === s.dep_date && s.dep_time && s.arr_time && s.arr_time < s.dep_time))) e[`${p}arr_date`] = "La llegada debe ser posterior a la salida";
    });
  });
  return e;
};

export const labelFlights = async (f) => {
  if (!f) return f;
  try {
    const [aps, als] = await Promise.all([loadAirports(), loadAirlines()]);
    const ap = Object.fromEntries(aps.map((a) => [a[0], a]));
    const al = Object.fromEntries(als.map((a) => [a.code, a]));
    const out = {};
    Object.entries(f).forEach(([leg, segs]) => {
      out[leg] = segs.map((s) => ({ ...s, airline_name: al[s.airline]?.name || s.airline, has_logo: !!al[s.airline]?.has_logo,
        from_label: airportLabel(ap[s.from_code]) || s.from_code, to_label: airportLabel(ap[s.to_code]) || s.to_code }));
    });
    return out;
  } catch { return f; }
};

const dmy = (d, en) => { if (!d) return ""; const [y, m, dd] = d.split("-"); return en ? `${m}/${dd}/${y}` : `${dd}/${m}/${y}`; };
export const when = (d, t, en) => [dmy(d, en), t].filter(Boolean).join(" ");
